import { render, staticRenderFns } from "./AdditionalAuthorBlock.vue?vue&type=template&id=0927d294"
import script from "./AdditionalAuthorBlock.vue?vue&type=script&lang=js"
export * from "./AdditionalAuthorBlock.vue?vue&type=script&lang=js"
import style0 from "./AdditionalAuthorBlock.vue?vue&type=style&index=0&id=0927d294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports